// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2cGnm","errorLogs":"EditorFooter_errorLogs__3-Dc8"};